import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { InsightCardModule } from '../../ui/card';
import { UIKitButtonModule } from '../button';
import { UIKitIconModule } from '../icon';
import { UIKitSquareButtonModule } from '../square-button/square-button.module';
import { UIKitStepper } from './stepper.component';

@NgModule({
  imports: [
    CommonModule,
    CdkStepperModule,
    UIKitButtonModule,
    UIKitIconModule,
    TranslocoModule,
    UIKitSquareButtonModule,
    InsightCardModule,
    UIKitStepper,
  ],
  exports: [UIKitStepper],
})
export class UIKitStepperModule {}
